import { render, staticRenderFns } from "./CoinPayment_.vue?vue&type=template&id=435294e2&"
import script from "./CoinPayment_.vue?vue&type=script&lang=js&"
export * from "./CoinPayment_.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports